const SvgTransform3 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M16 208h32v32H16zM80 208h32v32H80zM144 208h32v32h-32zM16 144h32v32H16zM80 144h32v32H80zM144 144h32v32h-32z"
    />
    <circle cx={32} cy={32.07} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={95.8} cy={32} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={160} cy={32} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={32} cy={351.93} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={96} cy={352} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={160} cy={352} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M16 80.07h32v32H16zM80 80h32v32H80zM144 80h32v32h-32z"
    />
    <circle cx={32} cy={96} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={96} cy={96} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={160} cy={96} r={16} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m16 240 16-32 16 32H16zM80 240l16-32 16 32H80zM144 240l16-32 16 32h-32zM16 304l16-32 16 32H16zM80 304l16-32 16 32H80zM144 304l16-32 16 32h-32zM16 368.07l16-32 16 32H16zM80 368l16-32 16 32H80zM144 368l16-32 16 32h-32z"
    />
  </>
);

export default SvgTransform3;
